module.exports = __webpack_public_path__ + "img/RX1HS.b37bda6c.jpg";